<template>
  <div class="modal">
    <div class="modal__wrapper">
      <button class="close modal__close" @click="$emit('on-close')">
        <fa-icon icon="times"></fa-icon>
      </button>
      <div class="modal__title">Ritprijs berekenen</div>
      <div class="modal__body">
        <div>
          <div class="address-input">
            <input
              type="text"
              class="input"
              v-model="addressInput"
              placeholder="Voer een adres in"
              @keyup.enter="addAddress"
            />
            <button class="button button--accept" @click="addAddress">
              Toevoegen
            </button>
          </div>
          <ul class="address-list">
            <li v-for="(address, index) in addresses" :key="index">
              <div>
                <span>{{ address }}</span>
                <button
                  class="button button--cancel"
                  @click="removeAddress(index)"
                >
                  Verwijderen
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="price-data" v-if="priceModel">
        <p v-if="loading">Loading...</p>
        <div v-else>
          <span v-for="key in Object.keys(priceModel)" :key="key"
            >{{ key }}: {{ priceModel[key] }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PriceCalculator",
  data() {
    return {
      loading: false,
      addressInput: "",
      addresses: [],
      priceModel: null,
    };
  },
  watch: {
    addresses: {
      handler(newVal) {
        console.log("Addresses changed:", newVal);
        if (newVal.length >= 2) {
          this.calculatePrice();
        }else{
            this.priceModel = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    addAddress() {
      if (this.addressInput && this.addressInput.trim() !== "") {
        this.addresses.push(this.addressInput.trim());
        this.addressInput = "";
      }
    },
    removeAddress(index) {
      this.addresses.splice(index, 1);
    },
    async calculatePrice() {
      if (this.addresses.length < 2) {
        alert("Voer ten minste twee adressen in om de prijs te berekenen.");
        return;
      }
      this.loading = true;
      try {
        // Simuleer een API-aanroep om de prijs te berekenen
        const response = await this.$store.dispatch(
          "dispatch/calculateRitPrijs",
          {
            origin: this.addresses[0],
            destination: this.addresses[this.addresses.length - 1],
            waypoints: this.addresses.slice(1, -1),
          }
        );
        this.priceModel = response;
      } catch (error) {
        console.error("Fout bij het berekenen van de prijs:", error);
        alert("Er is een fout opgetreden bij het berekenen van de prijs.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.address-input {
  display: flex;
  margin-bottom: 10px;
}
.address-input .input {
  flex: 1;
  margin-right: 10px;
}
.modal__wrapper {
  width: 100%;
  max-width: 600px;
}
li > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
}
ul {
  max-height: 40vh;
  overflow-y: auto;
  padding-right: 4px;
}
.price-data > div{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap:1rem;
}
</style>
